import React, { useEffect } from "react";
import { Box, Container, Typography, useMediaQuery, useTheme } from '@mui/material';
import {Breadcrumbs as BreadcrumbsMUI} from '@mui/material';
import Link from '@mui/material/Link';
import ConfigurationHelper from "../../configuration/ClientConfigurationHelper";
import { LAYOUT } from "../../configuration/theme";
const SCHEMA_ID = "tvp-breadcrumbs-schema";

const breadcrumbsStructureData = (listOfItems) => {
    const existing = document.getElementById(SCHEMA_ID);
    const schema = existing || document.createElement("script");
    schema.id = SCHEMA_ID;
    const items = listOfItems.filter(f => f.url).map((element, index) => {
        let itemsObj = {
            "@type": "ListItem",
            "position": index,
            "name": element.name
        };
        if (element.url !== "#") itemsObj["item"] = element.url;
        return itemsObj;
    });
    const schemaStructure = {
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": items
    };
    schema.type = "application/ld+json";
    schema.text = JSON.stringify([schemaStructure]);
    if (!existing) document.querySelector("head").appendChild(schema);
};

const Breadcrumbs = ({ breadcrumbsList = [], isHomePage = false, renderStructureData = true, ...rest }) => {
    const props = { breadcrumbsList, isHomePage, renderStructureData, ...rest };
    const theme = useTheme();
    let list = [
        {
            url: ConfigurationHelper.getGlobalConfiguration().public_base_url + "/",
            name: "Home",
            active: false
        }
    ];
    if(props.isHomePage){
        list.push({
            url: ConfigurationHelper.getGlobalConfiguration().public_base_url + ConfigurationHelper.getGlobalConfiguration().sub_folder + "/",
            name: "Aero A-Team",
            active: true
        });
    }
    list = [...list, ...props.breadcrumbsList];

    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const schemaKey = props.renderStructureData ? JSON.stringify(list) : null;

    useEffect(() => {
        if (schemaKey) breadcrumbsStructureData(JSON.parse(schemaKey));
    }, [schemaKey]);

    return (
        <Container maxWidth="xl" sx={{px: LAYOUT.pagePad, py: 2}}>
            <Box display={"flex"} justifyContent="space-between" role="presentation">
                <BreadcrumbsMUI aria-label="breadcrumb">
                    {list.filter(f=> {
                        if(isMobile){
                            if(f.hideMobile === true)
                                return false;
                        }
                        return true;
                    }).map((item, index) => {

                        if (item.active || !item.url || item.url === "#") {
                            return (<Typography
                                key={index}
                                component="span"
                                aria-current={item.active ? "page" : undefined}
                                sx={{fontSize: "12px"}}
                                color={"inherit"}
                            >
                                {item.name}
                            </Typography>)
                        }

                        return (<Link
                            sx={{
                                fontSize: "12px"
                            }}
                            key={index}
                            underline="hover"
                            color={"text.primary"}
                            href={item.url}
                        >
                            {item.name}
                        </Link>)
                    })}
                </BreadcrumbsMUI>
            </Box>
        </Container>
    );
};

export default Breadcrumbs;